export const isCheckInvalids = (invalids) => Object.values(invalids).every((invalid) => invalid.type !== 'error');
